<div role="dialog">
  <h1 role="heading" aria-level="2" id="landingErrorInfoHeading" class="dialog_info-dialog-title "> We were unable to
    locate your quote</h1>
  <div *ngIf="!bdqQuote">
    <div *ngIf="fullErrorContent; else customContent" id="infoContent" class="infoDialogContent"
      class="dialog_info-dialog-content">
      Please try again or if you would like to speak to Farmers<sup>®</sup> representative immediately, call<a
        href="tel:18005151896" aria-label="Contact farmers representative at 1-800-515-1896"> 1-800-515-1896</a>.<br>
      If you're an employee or member of a group with access to the Farmers GroupSelect<sup>&#8480;</sup>
      program, please call <a href="tel:1-855-793-0094" id="fws"
        aria-label="Contact farmers representative at 1-855-793-0094">1-855-793-0094</a>.
    </div>
    <ng-template #customContent>
      <div id="infoContent" class="infoDialogContent" class="dialog_info-dialog-content">
        Please try again or if you would like to speak to Farmers<sup>®</sup> representative immediately, <a
          href="tel:18003276377" aria-label="Contact farmers representative at 800-FARMERS">call 800-FARMERS</a>.
      </div>
    </ng-template>
  </div>
  <div *ngIf="bdqQuote">
    <div id="infoContent" class="infoDialogContent"
      class="dialog_info-dialog-content">
      Please try again or if you would like to speak to Bristol West<sup>®</sup> representative immediately, call<a
        href="tel:18662284622" aria-label="Contact bristol west representative at 1-866-228-4622"> 1-866-228-4622</a>.
    </div>
  </div>
  <div class="dialog_info-dialog-button-holder">
    <button mat-button mat-dialog-close class="dialog__info-dialog-button-close close-button"
      (click)="dialogRef.close()" (keydown.esc)="dialogRef.close()">CLOSE</button>
  </div>
</div>